export default {
    excess: 'Självrisk',
    security: 'Säkerhetsdeposition',
    fuel_policy: 'Bränslepolicy',
    like_for_like: 'Lika för lika',
    full_to_full: 'Full till full',
    mileage: 'Milantal: {mileage} miles per hyrperiod',
    unlimited_mileage: 'Obegränsat milantal',
    non_refundable: 'Ej återbetalbar',
    free_cancellation_until: 'Gratis avbokning fram till {date}',
    cancellation_with_terms: 'Avbokning {0} i linje med',
    t_c_text: 'villkor',
    two_free_extras: 'Två gratis tillval vid hämtning',
    glass_tyres_covered: 'Täckning för fönster och däck'
}
